import React, {useEffect, useState} from 'react';
import {BorrowRequestPopupProps} from "../../models";
import {DownloadContract, StyledPopUp} from "../../../../shared";
import {Button, Card, Col, Flex} from "antd";
import style from "./BorrowRequestPopup.module.scss";
import {RiShieldCheckFill} from "react-icons/ri";
import {StyledTag} from "./BorrowRequestPopup.styled";
import moment from "jalali-moment";
import TextArea from "antd/es/input/TextArea";
import {StyledButton} from "../orders/Orders.styled";
import {
    registerBorrowRequestApprovalByBorrower,
    registerBorrowRequestApprovalByOwner, sendApprovalOTP
} from "../../actions/Cartable.action";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import SharedService from "../../../../shared/services/Shared.service";
import OTPApprovalModal from "../otpApprovalModal/OTPApprovalModal";

const BorrowRequestPopup = ({open ,onCanselHandel,data,registerBorrowRequestApprovalByOwner,registerBorrowRequestApprovalByBorrower,sendApprovalOTP} :BorrowRequestPopupProps) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [openOtpModal, setOpenOtpModal] = useState<boolean>(false)
    const [showContract, setShowContract] = useState<boolean>(false)
    const [description, setDescription] = useState<string>("")
    const [secondsLeft, setSecondsLeft] = useState<number>()
    let status = data?.borrowStatus?.id;
    const _registerBorrowRequestApprovalByOwner = (isApproved:boolean) => {
        setLoading(true)
        let model = {
            id :data?.id,
            isApproved:isApproved,
            lenderDescription:description,
        }
        registerBorrowRequestApprovalByOwner(model)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    onCanselHandel()
                }
            })
            .catch((e: any) => {
            });
    };
    const _sendApprovalOTP = () => {
        setLoading(true)
        sendApprovalOTP()
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    setSecondsLeft(data.payload.data.secondsLeft)
                    setOpenOtpModal(true)
                }
            })
            .catch((e: any) => {
            });
    };
    const _DownloadContract = () => {
        setLoading(true)

        SharedService.downloadContract(data?.contractFileId)
            .then((data: any) => {
                setLoading(false)
                if (data != undefined) {
                    const url = URL.createObjectURL(new Blob([data], { type: "/DownloadContract/fulfilled" }));
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "قرارداد اجاره.pdf";
                    a.click();
                }
            })
            .catch((e: any) => {
            });
    };
    const onCanselHandelOTpModal = () => {
        setOpenOtpModal(false)
    }
    useEffect(() => {
        if (status === 4)
            setShowContract(true)
    }, [data]);
    return (
        <StyledPopUp
            open={open}
            onCancel={onCanselHandel}
            title={`درخواست اجاره`}
            width={"100%"}
            footer={null}
            transitionName={''}

        >
               <Flex gap={"large"} vertical >

                   <Flex gap={"large"}  vertical justify={"space-between"} >
                       <Flex justify={"start"}>
                           <span className={style.requestDetailTitle}>{data?.product?.name}</span>
                       </Flex>

                       <Flex justify={"space-between"} align={"end"}>
                           <Flex vertical gap={"small"}>
                               <span className={style.requestDetailText}>از تاریخ <StyledTag>{moment(data.startDate).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</StyledTag></span>
                               <span className={style.requestDetailText}>تا تاریخ <StyledTag>{moment(data.endDate).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</StyledTag></span>

                           </Flex>

                       </Flex>
                       <Flex>
                           <span className={style.price}>مبلغ دریافتی:</span>
                           <span className={style.price}>{data?.calculatedPrice}</span>
                           <span className={style.price}>ت</span>
                       </Flex>
                   </Flex>

                   <Flex vertical gap={"large"}>
                       <span> توضیحات درخواست دهنده: {data?.borrowerDescription}</span>
                       {status!== 1 &&<span> توضیحات اجاره دهنده: {data?.lenderDescription}</span>}
                       {showContract && <Button type={"primary"} onClick={_DownloadContract}>دانلود قرارداد</Button>}

                       {data?.isReceived && status===1 && <TextArea onClick={(event) =>
                           event.stopPropagation()} onChange={(value) => setDescription(value.target.value)}
                                                                    rows={3} placeholder={'توضیحات در صورت نیاز'}/>}
                       {(((data?.isReceived && status===1) ||
                           (!data?.isReceived && status===2 ))) && !showContract
                           && <Flex justify={"center"} gap={"small"}>
                               <Button loading={loading} onClick={(event) => {
                                   if (data?.isReceived)
                                   _registerBorrowRequestApprovalByOwner(true)
                                   else _sendApprovalOTP()
                                   event.stopPropagation()
                               }} block size={"middle"} type={"primary"}>تایید</Button>
                               <Button loading={loading} onClick={(event) => {
                                   _registerBorrowRequestApprovalByOwner(false)
                                   event.stopPropagation()
                               }} block size={"middle"}>رد کردن</Button>
                           </Flex>}
                   </Flex>
               </Flex>
            {openOtpModal &&<OTPApprovalModal id={data?.id} open={openOtpModal} onCanselHandel={onCanselHandelOTpModal}
                               secondsLeft={secondsLeft} onHandleOk={() => {
                setShowContract(true)
                setOpenOtpModal(false)
            }}/>}
        </StyledPopUp>
    );
};

export default connect(null, {registerBorrowRequestApprovalByOwner,registerBorrowRequestApprovalByBorrower,DownloadContract,sendApprovalOTP})(
    withRouter(BorrowRequestPopup)
);